var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter 1",
    clipPath: "url(#clip0_11_113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 3.33271C12.5166 3.54478 12.0014 3.68534 11.4644 3.75359C12.0169 3.42371 12.4386 2.90534 12.6368 2.28053C12.1217 2.58765 11.5529 2.80459 10.9468 2.92565C10.4577 2.40484 9.76056 2.08228 9.00006 2.08228C7.52456 2.08228 6.33669 3.2799 6.33669 4.74809C6.33669 4.95934 6.35456 5.16246 6.39844 5.35584C4.18275 5.24778 2.22219 4.18584 0.905125 2.56815C0.675187 2.96709 0.540313 3.42371 0.540313 3.91528C0.540313 4.83828 1.01562 5.65646 1.72413 6.13015C1.29594 6.12203 0.875875 5.99771 0.52 5.8019C0.52 5.81003 0.52 5.82059 0.52 5.83115C0.52 7.12628 1.44381 8.20203 2.65525 8.44984C2.43831 8.50915 2.20187 8.53759 1.9565 8.53759C1.78587 8.53759 1.61362 8.52784 1.45194 8.49209C1.79725 9.54753 2.77713 10.3235 3.94225 10.3486C3.0355 11.058 1.88419 11.4853 0.637812 11.4853C0.41925 11.4853 0.209625 11.4756 0 11.4488C1.18056 12.2101 2.57969 12.6448 4.0885 12.6448C8.99275 12.6448 11.674 8.58228 11.674 5.0609C11.674 4.94309 11.6699 4.82934 11.6643 4.7164C12.1932 4.34103 12.6376 3.87221 13 3.33271Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.863525)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter1);
export default __webpack_public_path__ + "static/media/twitter 1.8776d256869395edaa416e2a3ead36b2.svg";
export { ForwardRef as ReactComponent };